import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

import styles from "../../../styles.module.css"; // Importing CSS module for styles.

const ButtonTextLoading = (data) => {
  return (
    <div>
      {data.isSubmitting ? (
        <div>
          <CircularProgress size="1.5rem" className={styles.buttonLoader} />
        </div>
      ) : (
        `${data.body}`
      )}
    </div>
  );
};

export default ButtonTextLoading;
